import React, { useState } from "react";
import { Box, Paper, Tabs, Tab } from "@mui/material";
import InvoiceProduct from "./InvoiceProduct";
import InvoicePayments from "./InvoicePayments";

const InvoiceDetail = ({
  invoiceData,
  onInvoiceDataChange,
  payments,
  setPayments,
  productRows,
  setProductRows,
  productDescripcion,
  setProductDescripcion,
}) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_e, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ mx: "auto", mt: 3 }}>
      <Paper
        sx={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons={false}
          sx={{
            backgroundColor: "#1565C0",
            "& .MuiTab-root": {
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              minHeight: "48px",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              transition: "all 0.2s ease",
            },
            "& .Mui-selected": {
              backgroundColor: "#fff",
              color: "#1565C0",
              borderTop: "4px solid #1565C0",
              borderLeft: "4px solid #1565C0",
              borderRight: "4px solid #1565C0",
              borderBottom: "none",
              marginTop: "5px",
              marginLeft: "10px",
            },
            "& .MuiTabs-indicator": {
              display: "none",
            },
          }}
        >
          <Tab label="Productos" />
          <Tab label="Formas de Pago" />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {tabValue === 0 && (
            <InvoiceProduct
              rows={productRows}
              setRows={setProductRows}
              descripcion={productDescripcion}
              setDescripcion={setProductDescripcion}
              onProductDataChange={onInvoiceDataChange}
            />
          )}

          {tabValue === 1 && (
            <InvoicePayments
              totalPagar={Number(invoiceData?.total || 0)}
              payments={payments}
              setPayments={setPayments}
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default InvoiceDetail;
